export const categories = [
  {
    id: 1,
    name: 'الإلكترونيات',
    slug: 'electronics',
    count: 245,
    image: 'https://public.readdy.ai/ai/img_res/42bf9d6964a3f1001d27d6892596e98a.jpg'
  },
  {
    id: 2,
    name: 'الأزياء',
    slug: 'fashion',
    count: 389,
    image: 'https://readdy.ai/api/search-image?query=stylish%20fashion%20clothing%20and%20accessories%20on%20clean%20white%20minimalist%20background%2C%20elegant%20garments%20and%20trendy%20items%20arranged%20beautifully%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=cat-002&orientation=squarish'
  },
  {
    id: 3,
    name: 'المنزل والديكور',
    slug: 'home-decor',
    count: 156,
    image: 'https://readdy.ai/api/search-image?query=home%20decor%20items%20and%20interior%20accessories%20on%20clean%20white%20minimalist%20background%2C%20elegant%20decorative%20pieces%20arranged%20tastefully%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=cat-003&orientation=squarish'
  },
  {
    id: 4,
    name: 'الرياضة واللياقة',
    slug: 'sports',
    count: 198,
    image: 'https://readdy.ai/api/search-image?query=sports%20equipment%20and%20fitness%20gear%20on%20clean%20white%20minimalist%20background%2C%20athletic%20items%20and%20workout%20accessories%20arranged%20professionally%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=cat-004&orientation=squarish'
  },
  {
    id: 5,
    name: 'الجمال والعناية',
    slug: 'beauty',
    count: 267,
    image: 'https://readdy.ai/api/search-image?query=beauty%20products%20and%20cosmetics%20on%20clean%20white%20minimalist%20background%2C%20skincare%20items%20and%20makeup%20arranged%20elegantly%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=cat-005&orientation=squarish'
  },
  {
    id: 6,
    name: 'الألعاب',
    slug: 'toys',
    count: 134,
    image: 'https://readdy.ai/api/search-image?query=colorful%20toys%20and%20games%20on%20clean%20white%20minimalist%20background%2C%20playful%20items%20arranged%20cheerfully%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=cat-006&orientation=squarish'
  },
  {
    id: 7,
    name: 'الكتب والقرطاسية',
    slug: 'books',
    count: 178,
    image: 'https://readdy.ai/api/search-image?query=books%20and%20stationery%20items%20on%20clean%20white%20minimalist%20background%2C%20elegant%20reading%20materials%20and%20office%20supplies%20arranged%20neatly%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=cat-007&orientation=squarish'
  },
  {
    id: 8,
    name: 'الإكسسوارات',
    slug: 'accessories',
    count: 223,
    image: 'https://readdy.ai/api/search-image?query=fashion%20accessories%20and%20jewelry%20on%20clean%20white%20minimalist%20background%2C%20elegant%20watches%20bags%20and%20accessories%20arranged%20beautifully%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=cat-008&orientation=squarish'
  }
];
